export default {"src":"/_next/static/media/corner-boxes.315df797.svg","height":193,"width":176,"blurWidth":0,"blurHeight":0};